import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";
import { Brain, Clock, Lock, Sparkles } from "lucide-react";

const CATEGORIES = [
  { v: "", l: "Semua" },
  { v: "iq", l: "Tes IQ" },
  { v: "personality", l: "Kepribadian" },
  { v: "career", l: "Karier" },
  { v: "interest", l: "Minat Bakat" },
  { v: "development", l: "Tumbuh Kembang" },
  { v: "school_readiness", l: "Kesiapan Sekolah" },
];

export default function Tests() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("");
  useEffect(() => {
    api.get(`/tests${cat ? `?category=${cat}` : ""}`).then(r => setItems(r.data));
  }, [cat]);
  return (
    <div data-testid="tests-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container">
          <div className="lumina-label mb-3">Self Tests</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 max-w-3xl">Kenali dirimu lewat <em className="text-[#6B4BA3] italic font-normal">tes psikologi</em> profesional.</h1>
          <p className="text-lg text-[#5C5870] max-w-2xl">Tes online yang dirancang psikolog berlisensi: IQ, kepribadian, minat bakat, kesiapan kerja, hingga tumbuh kembang anak.</p>
          <div className="flex flex-wrap gap-3 mt-10">
            {CATEGORIES.map(c => (
              <button key={c.v} onClick={() => setCat(c.v)} data-testid={`filter-test-${c.v || "all"}`}
                className={`px-5 py-2 rounded-full text-sm font-medium ${cat === c.v ? "bg-[#6B4BA3] text-white" : "bg-white border border-[#E2DFED] text-[#5C5870] hover:border-[#6B4BA3]"}`}>
                {c.l}
              </button>
            ))}
          </div>
        </div>
      </section>
      <section className="lumina-container py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(t => (
            <Link to={`/tests/${t.slug}`} key={t.id} className="lumina-card overflow-hidden group" data-testid={`test-card-${t.slug}`}>
              <div className="aspect-[16/10] overflow-hidden relative">
                <img src={t.image} alt={t.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute top-3 left-3 bg-white/90 backdrop-blur rounded-full px-3 py-1 text-xs font-medium text-[#6B4BA3] flex items-center gap-1">
                  {t.price === 0 ? <Sparkles className="w-3 h-3" /> : <Lock className="w-3 h-3" />}
                  {t.price === 0 ? "GRATIS" : "PREMIUM"}
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-2">
                  <Brain className="w-3.5 h-3.5 text-[#6B4BA3]" />
                  <span className="lumina-label">{t.target_audience || t.category}</span>
                </div>
                <h3 className="font-serif text-xl text-[#1A1728] mb-2 leading-tight">{t.title}</h3>
                <p className="text-sm text-[#5C5870] line-clamp-2 mb-4">{t.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[#6B4BA3] font-semibold">{t.price === 0 ? "Gratis" : formatRupiah(t.price)}</span>
                  <span className="text-xs text-[#5C5870] flex items-center gap-1"><Clock className="w-3 h-3" /> {t.duration_minutes} mnt</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        {items.length === 0 && <p className="text-center text-[#5C5870] py-20">Belum ada tes di kategori ini.</p>}
      </section>
    </div>
  );
}
